import React, { useState } from "react";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useI18n } from "../i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = "/api";

export function Login({ onUserLogged }) {
  const { lang, setLang, t } = useI18n();
  const [showAdmin, setShowAdmin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pwVisible, setPwVisible] = useState(false);
  const [adminEmail, setAdminEmail] = useState("");
  const [adminPw, setAdminPw] = useState("");
  const [adminPwVisible, setAdminPwVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleUser = async (e, isAdmin = false) => {
    try {
      setLoading(true);
      const res = await axios.post(`${API}/auth/user/login`, { email: isAdmin ? adminEmail : email, password: isAdmin ? adminPw : password });
      onUserLogged(res.data.user_session_token, res.data.email);
    } catch (e) {
      alert(isAdmin ? t('login_admin_btn') + ' fehlgeschlagen' : t('login_user_btn') + ' fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shell light">
      <div className="loginCard lightCard upgradedCard">
        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
          <div>
            <h1 className="title darktxt">{t('app_title')}</h1>
            <p className="subtitle">{t('app_sub')}</p>
          </div>
          <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
            <select value={lang} onChange={(e)=>setLang(e.target.value)} title="Sprache / Language">
              <option value="de">DE</option>
              <option value="en">EN</option>
            </select>
            <img 
              src="/verkada-logo.png" 
              alt="Verkada Logo" 
              style={{
                height: '40px',
                width: 'auto',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>

        {/* User/Mandanten Login (groß) */}
        <div className="blockCard">
          <div className="field">
            <Label>{t('login_user_title')}</Label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="user@example.com" autoComplete="username" />
          </div>
          <div className="field">
            <div className="labelRow">
              <Label>{t('login_password')}</Label>
              <button className="linkBtn" type="button" onClick={()=>setPwVisible(v=>!v)}>{pwVisible ? t('hide_password') : t('show_password')}</button>
            </div>
            <Input type={pwVisible ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="********" autoComplete="current-password" />
          </div>
          <Button disabled={loading || !email || !password} onClick={(e)=>handleUser(e,false)} className="wideBtn">{loading ? t('login_please_wait') : t('login_user_btn')}</Button>
          <div className="tinyHint">{t('login_hint')}</div>
        </div>

        {/* Admin Login (klein, optional) */}
        <div className="small" style={{textAlign: "center", marginTop: 8}}>
          <span className="linkBtn" onClick={() => setShowAdmin(s => !s)}>
            {showAdmin ? t('login_admin_toggle_hide') : t('login_admin_toggle_show')}
          </span>
        </div>
        {showAdmin && (
          <div className="blockCard dashed">
            <div className="field">
              <Label>{t('login_admin_email')}</Label>
              <Input value={adminEmail} onChange={(e) => setAdminEmail(e.target.value)} placeholder="admin@example.com" autoComplete="username" />
            </div>
            <div className="field">
              <div className="labelRow">
                <Label>{t('login_password')}</Label>
                <button className="linkBtn" type="button" onClick={()=>setAdminPwVisible(v=>!v)}>{adminPwVisible ? t('hide_password') : t('show_password')}</button>
              </div>
              <Input type={adminPwVisible ? "text" : "password"} value={adminPw} onChange={(e) => setAdminPw(e.target.value)} placeholder="********" autoComplete="current-password" />
            </div>
            <Button disabled={loading || !adminEmail || !adminPw} onClick={(e)=>handleUser(e,true)} variant="secondary" className="wideBtn">{loading ? "Bitte warten…" : t('login_admin_btn')}</Button>
          </div>
        )}
      </div>
    </div>
  );
}
